import PropTypes from 'prop-types';
import React from 'react';
import { FormControl, FormGroup, HelpBlock } from 'react-bootstrap';
import RequirableControlLabel from '../RequirableControlLabel/RequirableControlLabel';
import './JobFormGroup.css';

const isError = (error, touched) => (error && touched ? 'error' : null);

// eslint-disable-next-line object-curly-newline
const JobFormGroup = ({ label, meta, input, required }) => (
  <FormGroup validationState={isError(meta.error, meta.touched)} >
    {label && <RequirableControlLabel required={required} >{label}</RequirableControlLabel> }
    <FormControl componentClass="select" placeholder="Job" {...input}>
      <option value="admin" >admin</option>
      <option value="foreman" >foreman</option>
      <option value="pm" >pm</option>
      <option value="employee" >employee</option>
      <option value="terminated" >Terminated</option>
      <option value="laid_off" >Laid Off</option>
    </FormControl>
    <FormControl.Feedback />
    {meta.error && meta.touched && <HelpBlock>{meta.error}</HelpBlock> }
  </FormGroup>
);

JobFormGroup.defaultProps = {
  meta: {},
  input: {},
  required: false,
};

JobFormGroup.propTypes = {
  label: PropTypes.string.isRequired,
  required: PropTypes.bool,
  meta: PropTypes.shape({}),
  input: PropTypes.shape({}),
};

export default JobFormGroup;



// WEBPACK FOOTER //
// ./src/components/Forms/JobFormGroup/JobFormGroup.jsx